import { ClientEvents } from 'common/events/ClientEvents';
import { QueryParams } from 'common/urls/QueryParams';
import React from 'react';
import {
  ClickableContainer,
  DefaultContainer,
  DishBody,
  DishFooter,
  DishFooterRow,
  HorizontalRule,
  ImageHeader,
} from 'src/shared/design-system/DishFirstCard/styles';
import { WavyEdge } from '../WavyEdge';
import { DishCardProps } from './types';

// NOTE: This should be renamed to DishCard if/when we remove the legacy explore page

export const trackDishCardClicked = (
  tracker,
  segmentMetrics,
  type: 'dish' | 'shef',
  filtersQueryParams,
  rank: number | undefined
) => {
  tracker.track(ClientEvents.SEGMENT_ITEM_CLICK, {
    segmentId: segmentMetrics.esid,
    segmentRenderedItems: segmentMetrics.renderedItems,
    segmentTotalItems: segmentMetrics.totalItems,
    position: segmentMetrics.pos,
    rank,
    type,
    filters: {
      spiceFilters: filtersQueryParams[QueryParams.SPICE_LEVEL_FILTER],
      cuisineFilters: filtersQueryParams[QueryParams.CUISINE_FILTER],
      dietaryFilters: filtersQueryParams[QueryParams.DIETARY_FILTER],
      dishTypeFilters: filtersQueryParams[QueryParams.DISH_TYPE_FILTER],
      priceFilters: filtersQueryParams[QueryParams.PRICE_LEVEL_FILTER],
      dateFilters: filtersQueryParams[QueryParams.DATE],
      proteinFilters: filtersQueryParams[QueryParams.PROTEIN_FILTER],
    },
  });
};

export const DishFirstCard: React.FC<DishCardProps> = ({
  className,
  imageContent,
  bodyContent,
  footerContent,
  onClick = null,
  useGrayBackground,
  containerHeight,
  footerRuleEnabled = true,
  href,
  ...rest
}) => {
  const combinedContent = (
    <>
      {imageContent && (
        <ImageHeader>
          {imageContent}
          <WavyEdge />
        </ImageHeader>
      )}
      {bodyContent && <DishBody>{bodyContent}</DishBody>}
      {footerContent && (
        <DishFooter useGrayBackground={useGrayBackground}>
          {footerRuleEnabled && <HorizontalRule />}
          <DishFooterRow>{footerContent}</DishFooterRow>
        </DishFooter>
      )}
    </>
  );
  const clickable = onClick != null;

  return clickable ? (
    <ClickableContainer
      onMouseDown={(e: React.MouseEvent<HTMLAnchorElement>) => {
        if (e.button === 0 && !e.metaKey && !e.ctrlKey) {
          // Only call onClick if main button.
          onClick?.();
        }
      }}
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        if (e.button === 0 && !e.metaKey && !e.ctrlKey) {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
      height={containerHeight}
      className={className}
      href={href ?? undefined}
      {...rest}>
      {combinedContent}
    </ClickableContainer>
  ) : (
    <DefaultContainer height={containerHeight} className={className} {...rest}>
      {combinedContent}
    </DefaultContainer>
  );
};
